// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"T9-z"};